import LinkList from "components/organizations/lists/LinkList/LinkList";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { UrlPageContainer } from "./UrlDetailPage.style";

const UrlDetailPage = () => {
  const { search } = useLocation();
  const url = useMemo(() => search.replace("?url=", ""), [search]);
  const year = new Date().getFullYear();
  return (
    <UrlPageContainer>
      <h2>과거 페이지로의 시간여행 시작!😎</h2>
      <LinkList url={url} year={year}/>
    </UrlPageContainer>
  );
};

export default UrlDetailPage;